import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Header, Footer } from '../../../Container.js';
import {
	Container,
	Tab,
	Row,
	Nav,
	Card,
	Button,
	Modal,
	Form,
	Col,
	FormControl,
	InputGroup,
	Tabs,
} from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import '../../../../assets/css/Cogen.css';
import { ReqGet, ReqPost } from '../../../../config/Requests.js';
import './JobApplicants.css';
import NewApplicants from './NewApplicants.js';
import SelectedApplicants from './selectedApplicants.jsx';
import ShortlistApplicants from './ShortlistApplicants.js';
import NewMessages from './NewMessages.js';
import Spinner from '../../../UI/Spinner/Spinner.js';
import moment from 'moment';
import { Multiselect } from 'multiselect-react-dropdown';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { MdInfo } from 'react-icons/md';
import DrafteJObModel from '../../../UI/Modal/Modal.js';
import { dateFormatter } from '../../../../helper/dateFormater.js';
import { toast } from 'react-toastify';
import { Box } from '@mui/material';
function JobApplicants({ location }) {
	const profile = useSelector(state => state.auth.profile);
	const navigate = useNavigate();

	const [applicantList, setApplicantList] = useState([]);
	const [selectedApplicantList, setSelectedApplicantList] = useState([]);
	const [shortlistapplicants, setShortlistApplicants] = useState([]);
	const [questionsList, setQuestionsList] = useState([]);
	const [data, setData] = useState({});
	const [showModel, setShowModel] = useState(false);
	const [dateMessage, setDateMessage] = useState('');
	const [pauseJobModel, setPauseJobModel] = useState(false);
	const [cancelModel, setCancelModel] = useState(false);

	const [request, setRequest] = useState({
		isInitiated: false,
		isSuccess: false,
		isFailed: false,
		shortlistApplicantsInitiated: false,
		shortlistApplicantsSuccess: false,
		shortlistApplicantsFailed: false,
	});
	const [questionsRequest, setQuestionsRequest] = useState({
		isInitiated: false,
		isSuccess: false,
		isFailed: false,
	});
	const [key, setKey] = useState('applicants');
	const [show, setShow] = useState(false);
	const [initialValues, setInitialValues] = useState({});
	const [showTooltip, setShowTooltip] = useState(false);

	useEffect(() => {
		console.log(location);
	}, []);
	// const location = useLocation();
	const { id, type } = useParams();
	const startDate = moment(data?.start_date).format('MM-DD-YYYY');
	const endDate = moment(data?.end_date).format('MM-DD-YYYY');
	const [tagsFormatedData, setTagFormatedData] = useState([]);
	let todayDate = new Date();
	todayDate = dateFormatter(todayDate, 'YYYY-MM-DD');
	useEffect(() => {
		if (type == 'applicants_question') {
			setKey('questions-answers');
		}
		setRequest({ isInitiated: true });
		ReqGet(`/jobs/${id}`)
			.then(({ data }) => {
				if (data.data.is_paused) navigate(`/job/${data.data.id}/paused`);
				if (data.data.is_filled || data.data.is_cancelled)
					navigate(`/job/${data.data.id}/archived-job`);

				setData(data?.data);
				setRequest({
					isInitiated: false,
					isSuccess: true,
					shortlistApplicantsInitiated: false,
				});
				const parents = data.data.tags.map(tag => {
					return {
						parent: tag.parent,
						child: [],
					};
				});

				const uniqueArray = Array.from(
					new Set(parents.map(JSON.stringify))
				).map(JSON.parse);

				for (let par = 0; par < uniqueArray.length; par++) {
					for (let child of data.data.tags) {
						if (uniqueArray[par].parent.id === child.parent.id) {
							// delete child.parent;
							uniqueArray[par].child = [...uniqueArray[par]?.child, child];
						}
					}
				}

				setTagFormatedData(uniqueArray);
			})
			.catch(err => {
				console.log(err);
				setRequest({ isSuccess: false, isFailed: true });
			});

		setRequest({ isInitiated: true });
		ReqGet(`job/${id}/applicants`)
			.then(res => {
				setApplicantList(res.data);
				setRequest({
					isInitiated: false,
					isSuccess: true,
					shortlistApplicantsInitiated: false,
				});
			})
			.catch(err => {
				console.log(err.response);
				setRequest({ isSuccess: false, isFailed: true });
			});

		ReqGet(`job/${id}/selectedapplicants`)
			.then(res => {
				setSelectedApplicantList(res.data);
				setRequest({
					isInitiated: false,
					isSuccess: true,
					shortlistApplicantsInitiated: false,
				});
			})
			.catch(err => {
				console.log(err.response);
				setRequest({ isSuccess: false, isFailed: true });
			});

		setQuestionsRequest({ isInitiated: true });
		ReqGet(`job/${id}/questions`)
			.then(res => {
				setQuestionsList(res.data);
				setQuestionsRequest({
					isInitiated: false,
					isSuccess: true,
					shortlistApplicantsInitiated: false,
				});
			})
			.catch(err => {
				console.log(err.response);
				setRequest({ isSuccess: false, isFailed: true });
			});

		setRequest({ shortlistApplicantsInitiated: true });
		ReqGet(`shortlist/job/${id}`)
			.then(res => {
				setShortlistApplicants(res.data);
				setRequest({
					shortlistApplicantsInitiated: false,
					shortlistApplicantsSuccess: true,
					isSuccess: true,
				});
			})
			.catch(err => {
				console.log(err.response);
				setRequest({
					shortlistApplicantsSuccess: false,
					shortlistApplicantsFailed: true,
				});
			});
	}, []);
	const shortlistHandler = (memberId, jobId) => {
		ReqPost(`shortlist/job/${jobId}`, { members: memberId })
			.then(res => {
				setRequest({ shortlistApplicantsInitiated: true });
				toast.success(res.data.message);

				ReqGet(`shortlist/job/${id}`)
					.then(res => {
						setShortlistApplicants(res.data);
						console.log(res.data);
						setRequest({
							shortlistApplicantsInitiated: false,
							shortlistpplicantsSuccess: true,
							isSuccess: true,
						});
					})
					.catch(err => {
						console.log(err.response);
						setRequest({ shortlistpplicantsSuccess: false, isFailed: true });
					});
			})
			.catch(err => {
				if (!err.response.data.status) {
					toast.info(err.response.data.message);
				}
				console.log(err.message);
			});
	};

	const declineShortlistHandler = (memberId, jobId) => {
		ReqPost(`remove-from-shortlist/job/${jobId}`, { members: memberId })
			.then(res => {
				console.log(res.data);
				setRequest({ shortlistApplicantsInitiated: true });
				ReqGet(`shortlist/job/${id}`)
					.then(res => {
						setShortlistApplicants(res.data);
						console.log(res.data);
						setRequest({
							shortlistApplicantsInitiated: false,
							shortlistpplicantsSuccess: true,
							isSuccess: true,
						});
					})
					.catch(err => {
						console.log(err.response);
						setRequest({ shortlistpplicantsSuccess: false, isFailed: true });
					});
			})
			.catch(err => {
				console.log(err.message);
			});
	};

	const declineApplicantHandler = (memberId, jobId) => {
		ReqPost(`decline-member/job/${jobId}`, { members: memberId })
			.then(res => {
				console.log(res.data);
				setRequest({ shortlistApplicantsInitiated: true });
				ReqGet(`job/${id}/applicants`)
					.then(res => {
						setApplicantList(res.data);
						console.log(res.data);
						setRequest({
							shortlistApplicantsInitiated: false,
							shortlistpplicantsSuccess: true,
							isSuccess: true,
						});
					})
					.catch(err => {
						console.log(err.response);
						setRequest({ shortlistpplicantsSuccess: false, isFailed: true });
					});
			})
			.catch(err => {
				console.log(err.message);
			});
	};

	const applyApplicantHandler = id => {
		ReqGet(`job/${id}/applicants`)
			.then(res => {
				setApplicantList(res.data);
				setRequest({
					isInitiated: false,
					isSuccess: true,
					shortlistApplicantsInitiated: false,
				});
			})
			.catch(err => {
				console.log(err.response);
				setRequest({ isSuccess: false, isFailed: true });
			});
	};

	const validationSchema = Yup.object().shape({
		description: Yup.string().required('*Description is required'),
		specific_qualification: Yup.string().required(
			'*Specific Qualification is required'
		),
		start_date: Yup.date().required('*This field is required'),
		end_date: Yup.date().required('*This field is required'),
	});

	const publishPausedJobHandler = (id, params) => {
		ReqPost(`resume/job/${id}`, params)
			.then(res => {
				if (res.status === 200) {
					toast.success('Job has been resumed Successfully');

					navigate('/');
				}
			})
			.catch(err => {
				console.log(err.response);
			});
	};

	const formSubmit = values => {
		if (initialValues.start_date > initialValues.end_date) {
			setDateMessage('end date must be greater than start date');
			return;
		}
		setDateMessage('');
		const today = new Date();
		let currentDate = new Date(
			today.getFullYear(),
			today.getMonth(),
			today.getDate(),
			0,
			0,
			0
		);
		const days = 15;
		currentDate = currentDate.setDate(currentDate.getDate() + days);
		currentDate = new Date(currentDate);
		currentDate = dateFormatter(currentDate, 'YYYY-MM-DD');
		if (initialValues.start_date < currentDate) {
			setShow(false);
			setShowModel(true);
			return;
		} else {
			setDateMessage('');
			const params = {
				...values,
				start_date: initialValues.start_date,
				end_date: initialValues.end_date,
			};
			publishPausedJobHandler(data.id, params);
			setShow(false);
		}
	};

	const resumeJob = () => {
		setInitialValues({
			description: data.description,
			specific_qualification: data.specific_qualification,
			start_date: data.start_date,
			end_date: data.end_date,
		});
		setShow(true);
	};
	const filledJob = () => {
		setInitialValues({
			description: data.description,
			specific_qualification: data.specific_qualification,
			start_date: data.start_date,
			end_date: data.end_date,
		});
		setShow(true);
	};
	const closeModel = () => {
		setShowModel(false);
	};
	const editJob = () => {
		setShowModel(false);
		setShow(true);
	};
	const pauseFunc = () => {
		setPauseJobModel(true);
	};
	const pauseJobConfirmed = () => {
		setPauseJobModel(false);
		ReqPost(`pause/job/${id}`)
			.then(res => {
				if (res.status === 200) {
					ReqGet('jobs')
						.then(res => {
							navigate('/');
							toast.success('Job has been Paused Successfully');
						})
						.catch(err => {
							console.log(err.response);
						});

					ReqGet('paused-jobs')
						.then(res => {})
						.catch(err => {
							console.log(err.response);
						});
				}
			})
			.catch(err => {
				console.log(err.response);
			});
	};

	const cancelJobSuccess = () => {
		setCancelModel(false);
		ReqPost(`cancel/job/${id}`)
			.then(res => {
				if (res.status === 200) {
					ReqGet('jobs')
						.then(res => {
							navigate('/');
							toast.success('Job has been cancelled Successfully');
						})
						.catch(err => {
							console.log(err.response);
						});
					ReqGet('archive-jobs')
						.then(res => {})
						.catch(err => {
							console.log(err.response);
						});
				}
			})

			.catch(err => {
				console.log(err.response);
			});
	};
	// console.log("data?.travel_type",data.is_cancel)
	// console.log('data.tags', data.tags);
	const iconStyle = {
		cursor: 'pointer',
		width: '80%',
		height: '0%',
	};

	const tooltipStyle = {
		position: 'absolute',
		bottom: '100%',
		left: '50%',
		transform: 'translateX(-50%)',
		backgroundColor: '#333',
		color: '#fff',
		padding: '5px',
		borderRadius: '5px',
		width: '742%',
		display: showTooltip ? 'block' : 'none',
	};
	return (
		<Container fluid='true'>
			<DrafteJObModel
				editBtn='UPDATE DATE'
				editJob={editJob}
				showModel={showModel}
				closeModel={closeModel}
			/>
			<Header type='client' />
			{/* Pause job confirmation Model  */}

			{/* <Modal show={pauseJobModel} onHide={() => setPauseJobModel(false)} centered>
        <Modal.Header >

        </Modal.Header>
        <Modal.Body style={{ margin: 'auto', fontSize: '20px', fontWeight: '600' }}>
        <em >
            Are You Sure you want to pause job.
        </em></Modal.Body>
        <Modal.Footer>
        <div style={{ margin: 'auto' }}>
            <Button variant="primary" onClick={() => pauseJobConfirmed()}>
            yes
            </Button> &nbsp;&nbsp;
            <Button variant="danger" onClick={() => setPauseJobModel(false)}>
            No
            </Button>
        </div>
        </Modal.Footer>
      </Modal> */}

			{/* new Pause Job Modal */}
			<Modal
				size='sm'
				show={pauseJobModel}
				onHide={() => setPauseJobModel(false)}
			>
				<Modal.Header className='no-border text-center'>
					<Modal.Title className='modal-title w-100 fw-bolder'>
						Pause Job
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className='text-center'>
					{' '}
					Are you sure you want to pause job.
				</Modal.Body>
				<Modal.Footer className='no-border'>
					<Button
						className='w-100  fw-bold btn-logout'
						variant='primary'
						onClick={pauseJobConfirmed}
					>
						PAUSE JOB
					</Button>
					<Button
						className='w-100 fw-bold btn-logout'
						variant='danger'
						onClick={() => setPauseJobModel(false)}
					>
						CANCEL
					</Button>
				</Modal.Footer>
			</Modal>

			{/* Cancel Model   */}

			{/* <Modal show={cancelModel} onHide={() => setCancelModel(false)} centered>
        <Modal.Header  >
        <Modal.Title ></Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ margin: 'auto', fontSize: '20px', fontWeight: '600' }}><em>Are you sure to want to cancel Job.</em></Modal.Body>
        <Modal.Footer>
        <div style={{ margin: 'auto' }}>
            <Button variant="primary" onClick={cancelJobSuccess}>
            Yes
            </Button> &nbsp;&nbsp;
            <Button variant="danger" onClick={() => setCancelModel(false)}>
        No
            </Button>
        </div>
        </Modal.Footer>
      </Modal> */}
			<Modal size='sm' show={cancelModel} onHide={() => setCancelModel(false)}>
				<Modal.Header className='no-border text-center'>
					<Modal.Title className='modal-title w-100 fw-bolder'>
						Cancel Job
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className='text-center'>
					Are you sure to want to cancel Job.
				</Modal.Body>
				<Modal.Footer className='no-border'>
					<Button
						className='w-100  fw-bold btn-logout'
						variant='primary'
						onClick={cancelJobSuccess}
					>
						YES
					</Button>
					<Button
						className='w-100 fw-bold btn-logout'
						variant='danger'
						onClick={() => setCancelModel(false)}
					>
						NO
					</Button>
				</Modal.Footer>
			</Modal>

			<div className='mt-3 p-0 col-md-10 offset-1'>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
					}}
				>
					<div>
						<Button
							onClick={() =>
								navigate({
									pathname: '/',
									// state: {
									// 	pageNumber: location.state?.pageNumber,
									// 	tab: location.state?.tab,
									// },
								})
							}
							variant='outline-primary btn-back-main'
						>
							Back
						</Button>

						<br />
						<br />
						<hr style={{ width: 'auto' }} />
						<h6 className='applicants-title-orange'>Job Post Candidates</h6>
						<h6 className='applicants-title-job-type'>
							{data.title} | {data?.requires_travel ? 'Required travel |' : ''}{' '}
							{data.job_location == 'remote' && 'Remote'}{' '}
							{data.job_location == 'both' && 'Both'}{' '}
							{data.job_location == 'onsite' && 'On-site'} |{' '}
							{data.job_type == 'fullTime' && 'Full Time'}{' '}
							{data.job_type == 'halfTime' && 'Half Time'}
						</h6>
					</div>
					<div>
						{!type && (
							<span>
								<Button style={{ marginRight: '5px' }} onClick={pauseFunc}>
									Pause Job
								</Button>
								<Button variant='danger' onClick={() => setCancelModel(true)}>
									Cancel Job
								</Button>
							</span>
						)}
					</div>
				</div>
				{!type ||
				(type == 'applicants_question' &&
					type !== 'pause' &&
					type !== 'archived-job') ? (
					<Tabs
						id='controlled-tab-example'
						activeKey={key}
						onSelect={k => setKey(k)}
						// defaultActiveKey='profile'
						className='mb-3'
					>
						<Tab
							eventKey='home'
							title={
								<ApplicantTabTitle
									key={key}
									request={request}
									applicantList={applicantList}
								/>
							}
						>
							<NewApplicants
								data={applicantList}
								declined={declineApplicantHandler}
								shortlisted={shortlistHandler}
								applyApplicantHandler={applyApplicantHandler}
							/>
						</Tab>
						<Tab
							eventKey='profile'
							title={
								<ShortlistTabTitle
									key={key}
									request={request}
									shortlistapplicants={shortlistapplicants}
								/>
							}
						>
							<ShortlistApplicants
								data={shortlistapplicants}
								declined={declineShortlistHandler}
							/>
						</Tab>
					</Tabs>
				) : (
					// <Tabs
					// 	id='controlled-tab-example'
					// 	activeKey={key}
					// 	onSelect={k => setKey(k)}
					// >
					// 	<Row className='cards-container rounded shadow-sm p-3 mb-5 bg-white'>
					// 		<Nav className='applicant-tab-selector'>
					// 			<Nav.Item style={{ width: '200px', height: '100px' }}>
					// 				<Nav.Link eventKey='applicants'>
					// 					<p
					// 						className={
					// 							key === 'applicants'
					// 								? 'card-heading-active'
					// 								: 'card-heading'
					// 						}
					// 					>
					// 						New Applicants
					// 					</p>
					// 					<p
					// 						className={
					// 							key === 'applicants'
					// 								? 'card-numbers-active'
					// 								: 'card-numbers'
					// 						}
					// 					>
					// 						{request.isSuccess === true ? (
					// 							applicantList.length
					// 						) : (
					// 							<Spinner
					// 								customStyle={{ fontSize: '26px', margin: 'auto' }}
					// 							/>
					// 						)}
					// 					</p>
					// 				</Nav.Link>
					// 			</Nav.Item>
					// 			<Nav.Item style={{ width: '200px', height: '100px' }}>
					// 				<Nav.Link eventKey='shortlisted'>
					// 					<p
					// 						className={
					// 							key === 'shortlisted'
					// 								? 'card-heading-active'
					// 								: 'card-heading'
					// 						}
					// 					>
					// 						Shortlisted
					// 					</p>
					// 					<p
					// 						className={
					// 							key === 'shortlisted'
					// 								? 'card-numbers-active'
					// 								: 'card-numbers'
					// 						}
					// 					>
					// 						{request.shortlistApplicantsInitiated === false ? (
					// 							shortlistapplicants.length
					// 						) : (
					// 							<Spinner
					// 								customStyle={{ fontSize: '26px', margin: 'auto' }}
					// 							/>
					// 						)}
					// 					</p>
					// 				</Nav.Link>
					// 			</Nav.Item>
					// 			{data.status !== 'SLM' ? (
					// 				<>
					// 					<Nav.Item
					// 						v-show="data.status !== 'QR2'"
					// 						style={{ width: '200px', height: '100px' }}
					// 					>
					// 						<Nav.Link eventKey='new-msges'>
					// 							<p
					// 								className={
					// 									key === 'new-msges'
					// 										? 'card-heading-active'
					// 										: 'card-heading'
					// 								}
					// 							>
					// 								New Questions
					// 							</p>
					// 							<p
					// 								className={
					// 									key === 'new-msges'
					// 										? 'card-numbers-active'
					// 										: 'card-numbers'
					// 								}
					// 							>
					// 								{questionsRequest.isSuccess === true ? (
					// 									questionsList.length
					// 								) : (
					// 									<Spinner
					// 										customStyle={{ fontSize: '26px', margin: 'auto' }}
					// 									/>
					// 								)}
					// 							</p>
					// 						</Nav.Link>
					// 					</Nav.Item>
					// 					<Nav.Item
					// 						v-show="data.status !== 'QR2'"
					// 						style={{ width: '200px', height: '100px' }}
					// 					>
					// 						<Nav.Link eventKey='questions-answers'>
					// 							<p
					// 								className={
					// 									key === 'questions-answers'
					// 										? 'card-heading-active'
					// 										: 'card-heading'
					// 								}
					// 							>
					// 								Questions/Answers
					// 							</p>
					// 							<p
					// 								className={
					// 									key === 'questions-answers'
					// 										? 'card-numbers-active'
					// 										: 'card-numbers'
					// 								}
					// 							>
					// 								{questionsRequest.isSuccess === true ? (
					// 									questionsList.length
					// 								) : (
					// 									<Spinner
					// 										customStyle={{ fontSize: '26px', margin: 'auto' }}
					// 									/>
					// 								)}
					// 							</p>
					// 						</Nav.Link>
					// 					</Nav.Item>
					// 				</>
					// 			) : (
					// 				''
					// 			)}
					// 		</Nav>
					// 	</Row>
					// 	<Tabs className='tabs-content-container'>
					// 		<Tab eventKey='applicants'>
					// 			{key == 'applicants' && (
					// 				<NewApplicants
					// 					data={applicantList}
					// 					declined={declineApplicantHandler}
					// 					shortlisted={shortlistHandler}
					// 					applyApplicantHandler={applyApplicantHandler}
					// 				/>
					// 			)}
					// 		</Tab>
					// 		<Tab eventKey='shortlisted'>
					// 			{' '}
					// 			{key == 'shortlisted' && (
					// 				<ShortlistApplicants
					// 					data={shortlistapplicants}
					// 					declined={declineShortlistHandler}
					// 				/>
					// 			)}
					// 		</Tab>
					// 		{data.status !== 'SLM' ? (
					// 			<>
					// 				<Tab eventKey='new-msges'>
					// 					{key == 'new-msges' && (
					// 						<NewMessages data={data} questionList={questionsList} />
					// 					)}
					// 				</Tab>
					// 				<Tab eventKey='questions-answers'>
					// 					{key == 'questions-answers' && (
					// 						<NewMessages data={data} questionList={questionsList} />
					// 					)}
					// 				</Tab>
					// 			</>
					// 		) : (
					// 			''
					// 		)}
					// 	</Tabs>
					// </Tabs>
					<div style={{ marginTop: '1px' }}></div>
				)}
				{type == 'archived-job' && !data.is_cancel && (
					<SelectedApplicants data={selectedApplicantList} />
				)}
				<Card className=' mb-2 job-view rounded shadow-sm p-3 mb-5 bg-white'>
					<Card.Body>
						<div className='row'>
							{data.is_paused ? (
								<div className='col-4'>
									<Button
										variant='success'
										style={{ fontWeight: 'bold' }}
										onClick={resumeJob}
									>
										Resume Job
									</Button>
								</div>
							) : (
								''
							)}
							{data.is_published ? (
								<div className='col-4'>
									<Button variant='success' onClick={filledJob}>
										Filled Job
									</Button>
								</div>
							) : (
								''
							)}
						</div>
						{/* <Card.Text className="text-job-orange">Sales Engineer | Requires Travel | {data.job_location}</Card.Text> */}

						{/* <Card.Text className="text-job-orange">Requirements:</Card.Text><br /> */}
						<Form style={{ border: '1px solid', marginTop: '12px' }}>
							<Row>
								<Col sm={12}>
									<div
										className={'top-actions bg-label'}
										style={{ borderBottom: ' 1px solid' }}
									>
										<Row style={{ marginLeft: '4px' }}>
											{/* Project id # */}
											<Col
												sm={4}
												style={{ marginTop: '4px', marginBottom: '4px' }}
											>
												<InputGroup controlId='formBasicEmail'>
													<InputGroup.Text
														className='fw-bold text-orange fw-bold ml-2'
														style={{ color: '#e07639' }}
													>
														Project ID #
													</InputGroup.Text>
													<Form.Control
														value={data?.job_id}
														name='job_id'
														rows='1'
													/>
												</InputGroup>
											</Col>
											{/* Job Title */}
											<Col
												sm={7}
												style={{ marginTop: '4px', marginBottom: '4px' }}
											>
												<InputGroup controlId='formBasicEmail'>
													<InputGroup.Text
														className='fw-bold text-orange  ml-2'
														style={{ color: '#e07639' }}
													>
														Job Title:
													</InputGroup.Text>
													<Form.Control
														value={data?.title}
														name='title'
														rows='1'
													/>
												</InputGroup>
											</Col>
										</Row>
									</div>
								</Col>
							</Row>
							{/* Administrative Data */}
							<h4 className={'heading fw-bold p-2 ml-2 rounded'}>
								Administrative Data
							</h4>
							<Row style={{ marginLeft: '4px' }}>
								<Col sm={6}>
									<InputGroup controlId='formBasicEmail'>
										<InputGroup.Text className='fw-bold fw-bold'>
											Priority Level:
										</InputGroup.Text>
										<Form.Control
											value={
												data?.priority
													? data.priority.charAt(0).toUpperCase() +
													  data.priority.slice(1)
													: ''
											}
											name='priority'
										></Form.Control>
									</InputGroup>
								</Col>

								{/*  Security Clearance*/}
								<Col sm={6}>
									<InputGroup controlId='formBasicEmail'>
										<InputGroup.Text className='fw-bold'>
											Security Clearance Required:
										</InputGroup.Text>
										<Form.Control
											value={
												data?.security_level === '1'
													? 'ITAR'
													: data?.security_level === '2'
													? 'Secret'
													: data?.security_level === '3'
													? 'Top Secret'
													: ''
											}
											name='security_level'
										/>
									</InputGroup>
								</Col>
							</Row>
							{/* No. of Positions */}
							<Col sm={6} style={{ marginTop: '18px', marginLeft: '14px' }}>
								<InputGroup controlId='formBasicEmail'>
									<InputGroup.Text className='fw-bold'>
										No. of Positions:
									</InputGroup.Text>
									<Form.Control
										value={data?.max_applicants}
										name='max_applicants'
										rows='1'
									/>
								</InputGroup>
							</Col>
							{/* Date */}
							<Row
								className='bg-label mt-4'
								style={{
									width: '98.6%',
									marginLeft: '16px',
									borderLeft: '1px solid',
									borderBottom: ' 1px solid',
									borderTop: ' 1px solid',
								}}
							>
								<Col sm={12} className='fw-bold p-1 ml-3 rounded fw-bold'>
									{' '}
									Date{' '}
								</Col>
							</Row>
							<Row
								style={{
									borderLeft: '1px solid',
									borderBottom: ' 1px solid',
									width: '98.6%',
									marginLeft: '16px',
								}}
							>
								<Col sm={12}>
									<Form.Group className='pl-5 mt-4'>
										<Row style={{ marginBottom: '18px' }}>
											<Col xs='auto'>
												{' '}
												<Form.Label style={{ fontWeight: 'bold' }}>
													{' '}
													Start Date:{' '}
												</Form.Label>{' '}
											</Col>
											<Col sm md={4}>
												<Form.Control
													aria-label='Start_date'
													value={data?.start_date}
												></Form.Control>
											</Col>
											<Col md={1} className='ml-4 mt-1'>
												<div
													style={{
														position: 'relative',
														display: 'inline-block',
													}}
												>
													<MdInfo
														style={iconStyle}
														onMouseEnter={() => setShowTooltip(true)}
														onMouseLeave={() => setShowTooltip(false)}
													/>
													<div style={tooltipStyle}>
														Start date must be Greater <br /> than 15 Days of
														Current day
													</div>
												</div>
											</Col>
											<Col xs='auto'>
												{' '}
												<Form.Label style={{ fontWeight: 'bold' }}>
													{' '}
													End Date:{' '}
												</Form.Label>{' '}
											</Col>
											<Col sm md={4}>
												<Form.Control
													aria-label='Start_date'
													value={data?.end_date}
												></Form.Control>
											</Col>
										</Row>
									</Form.Group>
								</Col>
							</Row>
							{/* Job Requesting Manager */}
							<Row
								className='bg-label mt-4'
								style={{
									width: '98.6%',
									marginLeft: '16px',
									borderLeft: '1px solid',
									borderBottom: ' 1px solid',
									borderTop: ' 1px solid',
								}}
							>
								<Col sm={12} className='fw-bold p-1 ml-3 rounded fw-bold'>
									{' '}
									Job Requesting Manager{' '}
								</Col>
							</Row>
							<Row
								style={{
									borderLeft: '1px solid',
									borderBottom: ' 1px solid',
									width: '98.6%',
									marginLeft: '16px',
									marginBottom: '15px',
								}}
							>
								<Col sm={12}>
									<ul className='list-group list-group-flush'>
										<li className='list-group-item fw-bold'>
											{/* {references.map((item, i) => { */}

											<InputGroup
												controlId='formBasicEmail'
												className='mb-4 mt-2'
											>
												<InputGroup.Text className='fw-bold'>
													Full Name:
													<span style={{ color: 'red' }}>*</span>
												</InputGroup.Text>
												<Form.Control
													name='manager_name'
													value={data?.manager_name}
												/>
											</InputGroup>
											<Row>
												<Col sm={6}>
													<InputGroup
														controlId='formBasicEmail'
														className='mb-4'
													>
														<InputGroup.Text className='fw-bold'>
															Email:
														</InputGroup.Text>
														<Form.Control
															name='manager_email'
															value={data?.manager_email}
														/>
													</InputGroup>
												</Col>
												<Col sm={6}>
													<InputGroup
														controlId='formBasicEmail'
														className='mb-2'
													>
														<InputGroup.Text className='fw-bold'>
															Phone Number:
														</InputGroup.Text>
														<Form.Control
															name='manager_phone'
															value={data?.manager_phone}
														/>
													</InputGroup>
												</Col>
											</Row>
										</li>
									</ul>
								</Col>
							</Row>
						</Form>

						{/*Job Profile  */}
						<Form style={{ border: '1px solid', marginTop: '12px' }}>
							<Row>
								<Col sm={12}>
									<div
										className={'top-actions bg-label'}
										style={{ borderBottom: ' 1px solid' }}
									>
										<h4
											className={'heading text-orange fw-bold p-2 ml-2 rounded'}
										>
											Job Profile
										</h4>
									</div>
								</Col>
							</Row>
							{/* Priority Level */}

							<h4 className={'heading fw-bold p-2 ml-2 rounded'}>
								General Data
							</h4>
							<Col sm={12}>
								<InputGroup
									controlId='formBasicEmail'
									style={{ padding: '10px' }}
								>
									<InputGroup.Text className='fw-bold'>
										Worker Type
									</InputGroup.Text>
									<Form.Control
										value={
											data?.worker_type === '1099-subcontractor'
												? '1099 Subcontractor'
												: data?.worker_type === 'w2-contingent-worker'
												? 'W2 Contingent Worker'
												: data?.worker_type === 'W-2-contingent-to-direct-hire'
												? 'W-2 Contingent to Direct Hire'
												: data?.worker_type === 'direct-hire-only'
												? 'Direct Hire Only'
												: ''
										}
										name=' worker_Type'
									/>
								</InputGroup>
							</Col>
							<Col sm={12} style={{ marginTop: '12px' }}>
								<InputGroup
									controlId='formBasicEmail'
									style={{ padding: '10px' }}
								>
									<InputGroup.Text className='fw-bold'>
										Job Type
									</InputGroup.Text>
									<Form.Control
										value={
											data?.job_type === 'fullTime'
												? 'Full-Time'
												: data?.job_type === 'halfTime'
												? 'Part-Time'
												: data?.job_type === 'both'
												? 'Full-Time and Part-Time'
												: ''
										}
										name='job_type'
									/>
								</InputGroup>
							</Col>
							{/* City and State */}
							<Row
								style={{
									width: '100%',
									marginLeft: '0px',
									marginBottom: '12px',
								}}
							>
								<Col sm={12} style={{ marginBottom: '12px' }}>
									<Row style={{ marginTop: '15px' }}>
										<Col sm={6}>
											<InputGroup controlId='formBasicEmail'>
												<InputGroup.Text className='fw-bold'>
													Job Location
												</InputGroup.Text>
												<InputGroup.Text className='fw-bold'>
													State
												</InputGroup.Text>
												<Form.Control name='states' value={data?.state?.name} />
											</InputGroup>
										</Col>
										<Col sm={6}>
											<InputGroup controlId='formBasicEmail'>
												<InputGroup.Text className='fw-bold'>
													City
												</InputGroup.Text>
												<Form.Control value={data?.city} />
											</InputGroup>
										</Col>
									</Row>
								</Col>
							</Row>
							<Col sm={12}>
								<InputGroup
									controlId='formBasicEmail'
									style={{ padding: '10px' }}
								>
									<InputGroup.Text className='fw-bold'>
										Site Location
									</InputGroup.Text>
									<Form.Control
										value={
											data?.job_location === 'remote'
												? 'Remote'
												: data?.job_location === 'both'
												? 'Both'
												: data?.job_location === 'onsite'
												? 'On-Site'
												: ''
										}
										name='job_type'
									/>
								</InputGroup>
							</Col>
							<Col sm={12} style={{ marginTop: '12px' }}>
								<InputGroup
									controlId='formBasicEmail'
									style={{ padding: '10px' }}
								>
									<InputGroup.Text className='fw-bold'>
										On-Site Meetings Required
									</InputGroup.Text>
									<Form.Control
										value={
											data?.onsite_meetings === 'yes'
												? 'Yes'
												: data?.onsite_meetings === 'no'
												? 'NO'
												: ''
										}
										name='job_type'
									/>
								</InputGroup>
							</Col>
							<Row
								style={{
									width: '100%',
									marginLeft: '0px',
									marginBottom: '12px',
								}}
							>
								<Col sm={12} style={{ marginBottom: '12px' }}>
									<Row style={{ marginTop: '15px' }}>
										<Col sm={6}>
											<InputGroup controlId='formBasicEmail'>
												<InputGroup.Text className='fw-bold'>
													Travel Required
												</InputGroup.Text>
												<Form.Control
													value={
														data?.travel_type === 'InState'
															? 'In-State'
															: data?.travel_type === 'Domestic'
															? 'Domestic (US Only)'
															: data?.travel_type === 'International'
															? 'International'
															: ''
													}
												/>
											</InputGroup>
										</Col>
										<Col sm={6}>
											<InputGroup controlId='formBasicEmail'>
												<InputGroup.Text className='fw-bold'>
													Duration %
												</InputGroup.Text>
												<Form.Control value={data?.travel_duration} />
											</InputGroup>
										</Col>
									</Row>
								</Col>
							</Row>
							<Row
								style={{
									width: '100%',
									marginLeft: '0px',
									marginBottom: '12px',
								}}
							>
								<Col sm={12} style={{ marginBottom: '12px' }}>
									<Row style={{ marginTop: '15px' }}>
										<Col sm={6}>
											<InputGroup controlId='formBasicEmail'>
												<InputGroup.Text className='fw-bold'>
													Destination
												</InputGroup.Text>
												<Form.Control value={data?.destination} />
											</InputGroup>
										</Col>
										<Col sm={6}>
											<InputGroup controlId='formBasicEmail'>
												<InputGroup.Text className='fw-bold'>
													Approx. Duration of Travel
												</InputGroup.Text>
												<Form.Control value={data?.approx_duration} />
											</InputGroup>
										</Col>
									</Row>
								</Col>
							</Row>
						</Form>
						{/* Job Specifications */}
						<Form style={{ border: '1px solid', marginTop: '12px' }}>
							<Row>
								<Col sm={12}>
									<div
										className={'top-actions bg-label'}
										style={{ borderBottom: ' 1px solid' }}
									>
										<h4
											className={'heading text-orange fw-bold p-2 ml-2 rounded'}
										>
											Job Specifications
										</h4>
									</div>
								</Col>
							</Row>
							<Col
								sm={12}
								style={{ marginTop: '12px', width: '99.3%', marginLeft: '4px' }}
							>
								<InputGroup
									controlId='formBasicEmail'
									style={{ padding: '10px' }}
								>
									<InputGroup.Text className='fw-bold'>
										Years Experience
									</InputGroup.Text>

									<Form.Control value={data?.year_experience} />
								</InputGroup>
							</Col>
							<Row style={{ marginLeft: '4px', marginTop: '12px' }}>
								<Col sm={6}>
									<InputGroup controlId='formBasicEmail'>
										<InputGroup.Text className='fw-bold'>
											Hourly Pay Rate Range
										</InputGroup.Text>
										<InputGroup.Text className='fw-bold'>
											Low End
										</InputGroup.Text>
										<Form.Control
											value={data?.start_pay_range}
											name='start_pay_range'
											type='text'
										/>
									</InputGroup>
								</Col>
								<Col sm={1}>
									<InputGroup controlId='formBasicEmail'>
										<InputGroup.Text className='fw-bold'>To</InputGroup.Text>
									</InputGroup>
								</Col>
								<Col sm={5}>
									<InputGroup
										controlId='formBasicEmail'
										style={{ width: '96%' }}
									>
										<InputGroup.Text className='fw-bold'>
											High End
										</InputGroup.Text>
										<Form.Control type='text' value={data?.end_pay_range} />
									</InputGroup>
								</Col>
							</Row>
							{data && (data.start_pay_range1 || data.end_pay_range1) ? (
								<Row style={{ marginLeft: '4px', marginTop: '12px' }}>
									<Col sm={6}>
										<InputGroup controlId='formBasicEmail'>
											<InputGroup.Text className='fw-bold'>
												Hourly Pay Rate Range
											</InputGroup.Text>
											<InputGroup.Text className='fw-bold'>
												Low End
											</InputGroup.Text>
											<Form.Control
												value={data?.start_pay_range1}
												name='start_pay_range1'
												type='text'
											/>
										</InputGroup>
									</Col>
									<Col sm={1}>
										<InputGroup controlId='formBasicEmail'>
											<InputGroup.Text className='fw-bold'>To</InputGroup.Text>
										</InputGroup>
									</Col>
									<Col sm={5}>
										<InputGroup
											controlId='formBasicEmail'
											style={{ width: '96%' }}
										>
											<span>
												<InputGroup.Text className='fw-bold'>
													High End
												</InputGroup.Text>
											</span>
											<Form.Control type='text' value={data?.end_pay_range1} />
										</InputGroup>
									</Col>
								</Row>
							) : null}

							{/* Job Description  */}
							<Row
								className='bg-label mt-4'
								style={{
									width: '98.6%',
									marginLeft: '16px',
									borderLeft: '1px solid',
									borderBottom: ' 1px solid',
									borderTop: ' 1px solid',
								}}
							>
								<Col sm={12} className='fw-bold p-1 ml-3 rounded fw-bold'>
									{' '}
									Job Description
								</Col>
							</Row>
							<Row
								style={{
									borderLeft: '1px solid',
									borderBottom: ' 1px solid',
									width: '98.6%',
									marginLeft: '16px',
								}}
							>
								<Col sm={12} className='mt-4 mb-4'>
									<Form.Control
										as='textarea'
										value={data?.description}
										rows='3'
									/>
								</Col>
							</Row>

							{/* Select General & Specific Expertise */}
							<Row
								className='bg-label mt-4'
								style={{
									width: '98.6%',
									marginLeft: '16px',
									borderLeft: '1px solid',
									borderBottom: ' 1px solid',
									borderTop: ' 1px solid',
								}}
							>
								<Col sm={12} className='fw-bold p-1 ml-3 rounded fw-bold'>
									{' '}
									Select General & Specific Expertise
								</Col>
							</Row>
							{tagsFormatedData?.map((tag, index) => {
								return (
									<Row
										key={index}
										style={{
											borderLeft: '1px solid',
											borderBottom: ' 1px solid',
											width: '98.6%',
											marginLeft: '16px',
										}}
									>
										{/*  */}
										<Row
											style={{
												marginTop: '15px',
												marginBottom: '15px',
											}}
										>
											<Col md={4}>
												<InputGroup
													controlId='formBasicEmail'
													style={{ marginLeft: '12px' }}
												>
													<InputGroup.Text className='fw-bold'>
														{index === 0
															? 'Primary General '
															: 'Secondary General'}
													</InputGroup.Text>
													{/*  Parent  */}
													<Form.Control value={tag.parent.name} />
												</InputGroup>
											</Col>
											{/* 1st child */}

											{tag.child.map((child, index) => {
												return (
													<Col key={index} md={4}>
														<InputGroup controlId='formBasicEmail'>
															<InputGroup.Text className='fw-bold'>
																Specific Field {index + 1}
															</InputGroup.Text>
															<Form.Control value={child.name} />
														</InputGroup>
													</Col>
												);
											})}
										</Row>
									</Row>
								);
							})}

							{/* Required Skills */}

							<Row
								className='bg-label mt-4'
								style={{
									width: '98.6%',
									marginLeft: '16px',
									borderLeft: '1px solid',
									borderBottom: ' 1px solid',
									borderTop: ' 1px solid',
								}}
							>
								<Col sm={12} className='fw-bold p-1 ml-3 rounded fw-bold'>
									{' '}
									Required Skills
								</Col>
							</Row>
							<Row
								style={{
									borderLeft: '1px solid',
									borderBottom: ' 1px solid',
									width: '98.6%',
									marginLeft: '16px',
								}}
							>
								<Col sm={12} className='mt-2'>
									<ul className='list-group list-group-flush'>
										<li className='list-group-item fw-bold'>
											{data?.specific_expertise?.map((item, i) => {
												return (
													<Form.Group key={i} controlId='formBasicEmail'>
														<Form.Control
															name='first_name'
															value={item}
															as='textarea'
															rows='1'
															style={{marginBottom:'12px'}}
														/>
													</Form.Group>
												);
											})}
										</li>
									</ul>
								</Col>
							</Row>
							{/* Recommended Skills */}
							<Row
								className='bg-label mt-4'
								style={{
									width: '98.6%',
									marginLeft: '16px',
									borderLeft: '1px solid',
									borderBottom: ' 1px solid',
									borderTop: ' 1px solid',
								}}
							>
								<Col sm={12} className='fw-bold p-1 ml-3 rounded fw-bold'>
									{' '}
									Recommended Skills
								</Col>
							</Row>
							<Row
								style={{
									borderLeft: '1px solid',
									borderBottom: ' 1px solid',
									width: '98.6%',
									marginLeft: '16px',
								}}
							>
								<Col sm={12} className='mt-2'>
									<ul className='list-group list-group-flush'>
										<li className='list-group-item fw-bold'>
											{data?.other_requirements?.map((item, i) => {
												return (
													<Form.Group key={i} controlId='formBasicEmail'>
														<Form.Control value={item} as='textarea' rows='1'  style={{marginBottom:'12px'}}/> 
													</Form.Group>
												);
											})}
										</li>
									</ul>
								</Col>
							</Row>
							{/* Tool Required/Recommended */}
							<Row
								className='bg-label mt-4'
								style={{
									width: '98.6%',
									marginLeft: '16px',
									borderLeft: '1px solid',
									borderBottom: ' 1px solid',
									borderTop: ' 1px solid',
								}}
							>
								<Col sm={12} className='fw-bold p-1 ml-3 rounded fw-bold'>
									{' '}
									Tool Required/Recommended
								</Col>
							</Row>
							<Row
								style={{
									borderLeft: '1px solid',
									borderBottom: ' 1px solid',
									width: '98.6%',
									marginLeft: '16px',
									marginBottom: '12px',
								}}
							>
								<Col sm={12} className='mt-2'>
									<ul className='list-group list-group-flush'>
										<li className='list-group-item fw-bold'>
											{data?.tool?.map((item, i) => {
												return (
													<Form.Group key={i} controlId='formBasicEmail'>
														<Form.Control value={item} as='textarea' rows='1' style={{marginBottom:'12px'}}/>
													</Form.Group>
												);
											})}
										</li>
									</ul>
									{/* <Row> */}
									{data?.must_own_tools?.map((item, i) => {
										return (
											<Col
												key={i}
												sm={5}
												style={{ marginBottom: '12px', marginLeft: '33px' }}
											>
												<Row style={{ marginTop: '15px' }}>
													<InputGroup controlId='formBasicEmail'>
														<InputGroup.Text className='fw-bold'>
															Must Own Tools
														</InputGroup.Text>
														<Form.Control value={item} />
													</InputGroup>
												</Row>
											</Col>
										);
									})}
									{data?.client_provides_tools?.map((item, i) => {
										return (
											<Col
												key={i}
												sm={5}
												style={{ marginBottom: '12px', marginLeft: '33px' }}
											>
												<Row style={{ marginTop: '15px' }}>
													<InputGroup controlId='formBasicEmail'>
														<InputGroup.Text className='fw-bold'>
															Client Provides Tools
														</InputGroup.Text>
														<Form.Control value={item} />
													</InputGroup>
												</Row>
											</Col>
										);
									})}
									{/* </Row> */}
								</Col>
							</Row>
						</Form>

						{/* <>
							<Card.Text className='text-job-orange'>
								Hourly Pay Rate Range
							</Card.Text>
							<Card.Text className='text-job-normal mb-4'>
								{data.start_pay_range}-{data.end_pay_range} per month
								&nbsp;&nbsp;
								{data.start_pay_range1 != null || data.end_pay_range1 != null
									? `And ${data.start_pay_range1 || ''}-${
											data.end_pay_range1 || ''
									} per month`
									: null}
							</Card.Text>

							<Card.Text className='text-job-orange'>Job Description</Card.Text>
							<Card.Text className='text-job-normal mb-4'>
								<p>{data.description}</p>
							</Card.Text>
							<Card.Text className='text-job-orange'>Tags</Card.Text>
							<Card.Text className='text-job-normal mb-4 cancel-rmv'>
								<div
									style={{
										display: 'flex',
										maxWidth: '65%',
										marginRight: '10px',
										flexWrap: 'wrap',
										border: '1px solid #e3dada',
										borderRadius: '10px',
									}}
								>
									{data?.tags?.map(d1 => {
										return (
											<>
												<div
													style={{
														display: 'flex',
														backgroundColor: '#0096fb',
														borderRadius: '10px',
														fontSize: '13px',
														color: 'white',
														padding: '7px',
														marginTop: '4px',
														marginBottom: '3px',
														marginLeft: '4px',
													}}
												>
													&nbsp; <div>{d1.display_name}</div>
												</div>
												&nbsp; &nbsp;
											</>
										);
									})}
								</div>
								
							</Card.Text>

							<Card.Text className='text-job-orange'>Required Skills</Card.Text>
							<Card.Text className='text-job-normal mb-4'>
								{data?.specific_expertise?.map((data, index) => (
									<div keys={index}>{data}</div>
								))}
							</Card.Text>
							<Card.Text className='text-job-orange'>
								Recommended Skills
							</Card.Text>

							<Card.Text className='text-job-normal mb-4'>
								{data?.other_requirements?.map((data, index) => (
									<div keys={index}>{data}</div>
								))}
							</Card.Text>
							<Card.Text className='text-job-orange'>Tools</Card.Text>
							<Card.Text className='text-job-normal mb-4'>
								{data?.tool?.map((data, index) => (
									<div keys={index}>{data} </div>
								))}
							</Card.Text>
							{data?.must_own_tools &&
								data.must_own_tools.filter(tool => tool.trim() !== '').length >
									0 && (
									<Card.Text className='text-job-orange'>
										Must Own Tools
									</Card.Text>
								)}
							<Card.Text className='text-job-normal mb-4'>
								{data?.must_own_tools
									? data.must_own_tools.map((ownToolsData, index) => (
											<div key={index}>{ownToolsData}</div>
									  ))
									: null}
							</Card.Text>
							{data?.client_provides_tools &&
								data.client_provides_tools.filter(tool => tool.trim() !== '')
									.length > 0 && (
									<Card.Text className='text-job-orange'>
										Client Provides Tools
									</Card.Text>
								)}

							<Card.Text className='text-job-normal mb-4'>
								{data?.client_provides_tools
									? data.client_provides_tools.map(
											(clientProvidesData, index) => (
												<div key={index}>{clientProvidesData}</div>
											)
									  )
									: null}
							</Card.Text>

							<Card.Text className='text-job-orange'>Location</Card.Text>
							<Card.Text className='text-job-normal mb-4'>
								{data.job_location == 'remote' && 'Remote'}{' '}
								{data.job_location == 'both' && 'Both'}{' '}
								{data.job_location == 'onsite' && 'On-Site'}
							</Card.Text>

							<Card.Text className='text-job-orange'>
								On-Site Meetings
							</Card.Text>
							<Card.Text className='text-job-normal mb-4'>
								<p>
									{data.onsite_meetings == 'no' && 'No'}{' '}
									{data.onsite_meetings == 'yes' && 'Yes'}
								</p>
							</Card.Text>

							<Card.Text className='text-job-orange'>Travel Type</Card.Text>
							<Card.Text className='text-job-normal mb-4'>
								{data.travel_type == 'InState' && 'In State'}{' '}
								{data.travel_type == 'Domestic' && 'Domestic (US Only)'}{' '}
								{data.travel_type == 'International' && 'International'}
							</Card.Text>
							<Card.Text className='text-job-orange'>
								Duration of Travel
							</Card.Text>
							<Card.Text className='text-job-normal mb-4'>
								{data.travel_duration}
							</Card.Text>
							<Card.Text className='text-job-orange'>
								Approx. Duration of Travel
							</Card.Text>
							<Card.Text className='text-job-normal mb-4'>
								{data.approx_duration}
							</Card.Text>
						</> */}
					</Card.Body>
				</Card>
			</div>

			<Modal
				size='md'
				show={show}
				onHide={() => {
					setShow(false);
					setDateMessage('');
				}}
			>
				<Modal.Header className='no-border text-center'>
					<Modal.Title className='modal-title w-100 fw-bolder'>
						Resume Job
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Formik
						initialValues={initialValues}
						validationSchema={validationSchema}
						onSubmit={(values, { setSubmitting, resetForm }) => {
							console.log('Values About fee', values);
							formSubmit(values, setSubmitting, resetForm);
						}}
					>
						{({
							errors,
							touched,
							values,
							handleSubmit,
							handleChange,
							setFieldValue,
							submitForm,
							handleBlur,
							isSubmitting,
						}) => (
							<Form>
								<Form.Group controlId='newJobGeneral'>
									<Form.Label className='text-primary fw-bold'>
										Job Description:<span style={{ color: 'red' }}>*</span>
									</Form.Label>
									<Form.Control
										onChange={handleChange}
										value={values.description}
										rows='1'
										name='description'
										className={`${
											errors.description && touched.description ? 'error' : ''
										}`}
										placeholder='Enter text here'
									/>
									{errors.description && touched.description ? (
										<div className={`red mb-1 fs15`}>{errors.description}</div>
									) : null}
								</Form.Group>
								<Form.Group controlId='newJobSq' className='mt-3'>
									<Form.Label className='text-primary fw-bold'>
										Specific qualifications:
										<span style={{ color: 'red' }}>*</span>
									</Form.Label>
									<Form.Control
										onChange={handleChange}
										value={values.specific_qualification}
										rows='1'
										name='specific_qualification'
										className={`${
											errors.specific_qualification &&
											touched.specific_qualification
												? 'error'
												: ''
										}`}
										placeholder='Enter specific qualification here'
									/>
									{errors.specific_qualification &&
									touched.specific_qualification ? (
										<div className={`red mb-1 fs15`}>
											{errors.specific_qualification}
										</div>
									) : null}
								</Form.Group>

								<hr></hr>

								<Row>
									<Col>
										<Form.Group controlId='newJobDate'>
											<Form.Label className='text-primary fw-bold'>
												Date:<span style={{ color: 'red' }}>*</span>
											</Form.Label>
											<Form.Group className='pl-2'>
												<span style={{ alignItems: 'baseline' }}>
													<Col xs='auto'>
														{' '}
														<Form.Label> Start Date </Form.Label>{' '}
													</Col>
													<Col>
														<FormControl
															placeholder='Select Start Date'
															type='date'
															onChange={e => {
																setInitialValues({
																	...initialValues,
																	start_date: e.target.value,
																});
															}}
															name='start_date'
															min={todayDate}
															max={initialValues.end_date}
															value={initialValues.start_date}
														/>
														{errors.start_date && touched.start_date ? (
															<div className={`red mb-1 fs15`}>
																{errors.start_date}
															</div>
														) : null}
													</Col>
													<Col xs='auto'>
														{' '}
														<Form.Label> End Date </Form.Label>{' '}
													</Col>
													<Col>
														<FormControl
															placeholder='Select End Date'
															type='date'
															onChange={e => {
																setInitialValues({
																	...initialValues,
																	end_date: e.target.value,
																});
															}}
															name='end_date'
															value={initialValues.end_date}
															min={initialValues.start_date}
														/>
														<p style={{ color: 'red' }}>{dateMessage}</p>
														{errors.end_date && touched.end_date ? (
															<div className={`red mb-1 fs15`}>
																{errors.end_date}
															</div>
														) : null}
													</Col>
												</span>
											</Form.Group>
										</Form.Group>
									</Col>
								</Row>

								<hr></hr>
								<div className={'text-center mt-4'}>
									{profile.user.is_subscribed === 1 ? (
										<div>
											<Button
												className='w-100  fw-bold btn-logout mb-1'
												variant='success'
												onClick={submitForm}
											>
												RESUME JOB
											</Button>
											<Button
												className='w-100 fw-bold btn-logout'
												variant='light'
												onClick={() => {
													setShow(false);
													setDateMessage('');
												}}
											>
												CANCEL
											</Button>
										</div>
									) : (
										<Button
											className='w-100 fw-bold btn-logout'
											variant='light'
											onClick={() => {
												setShow(false);
												setDateMessage('');
											}}
										>
											CANCEL
										</Button>
									)}
								</div>
							</Form>
						)}
					</Formik>
				</Modal.Body>
			</Modal>
			<Footer />
		</Container>
	);
}

export default JobApplicants;

const ShortlistTabTitle = ({ key, request, shortlistapplicants }) => {
	return (
		<Box>
			<p
				className={
					key === 'shortlisted' ? 'card-heading-active' : 'card-heading'
				}
			>
				Shortlisted
			</p>
			<p
				className={
					key === 'shortlisted' ? 'card-numbers-active' : 'card-numbers'
				}
			>
				{request.shortlistApplicantsInitiated === false ? (
					shortlistapplicants.length
				) : (
					<Spinner customStyle={{ fontSize: '26px', margin: 'auto' }} />
				)}
			</p>
		</Box>
	);
};

const ApplicantTabTitle = ({ key, request, applicantList }) => {
	return (
		<Box>
			<p
				className={
					key === 'applicants' ? 'card-heading-active' : 'card-heading'
				}
			>
				New Applicants
			</p>
			<p
				className={
					key === 'applicants' ? 'card-numbers-active' : 'card-numbers'
				}
			>
				{request.isSuccess === true ? (
					applicantList.length
				) : (
					<Spinner customStyle={{ fontSize: '12px', margin: 'auto' }} />
				)}
			</p>
		</Box>
	);
};
